import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { filter } from 'lodash';
import { Toggles } from '../../../../shared/constants/toggles.constant';
import { ToggleService } from '../../../../shared/services/toggle/toggle.service';
import { ImSchool } from '../../../services/im-models/im-school';
import { ImUser } from '../../../services/im-models/im-user';
import { ISchool } from '../../../typings/interfaces/school.interface';
import { IUser } from '../../../typings/interfaces/user.interface';
import { SettingsRoute, SettingsRoutesStates } from './../../../constants/settings-routes.constant';

export const SCHOOL_TYPE_ROUTES = {
  ems: ['Supports', 'Assessments', 'User management'],
  hs: ['Metrics', 'Master program', 'Supports', 'Activities', 'User management'],
  hybrid: ['Metrics', 'Master program', 'Supports', 'Assessments', 'Activities', 'User management'],
};

@Component({
  selector: 'settings-left-nav',
  template: require('./settings-left-nav.component.html'),
  styles: [require('./settings-left-nav.component.scss')],
})
export class SettingsLeftNavComponent implements OnInit {
  @Input() currentRoute: SettingsRoute;
  @Input() currentSchool: ISchool;
  @Input() currentUser: IUser;
  @Output() changeView: EventEmitter<any> = new EventEmitter<any>();

  private isHs: boolean;
  private is6to12: boolean;
  private isSchoolWideEditor: boolean;
  private isCaseloadUser: boolean;
  private restrictedRoutes: string[] = ['Metrics', 'Master program', 'User management'];
  public routeOptions: string[];
  public showAssessments: boolean;

  constructor(private imSchool: ImSchool, private imUser: ImUser, private toggleService: ToggleService) {
    // empty block
  }

  ngOnInit() {
    this.showAssessments = this.toggleService.getToggleState(Toggles.TOGGLE_NYCT_MVP);
    this.isHs = this.imSchool.isHighSchool(this.currentSchool);
    this.is6to12 = this.imSchool.isHybridSchool(this.currentSchool);
    this.isSchoolWideEditor = this.imUser.isSchoolWideEditor(this.currentUser);
    this.isCaseloadUser = this.imUser.isCaseloadUser(this.currentUser);
    this.routeOptions = this.getRouteOptions();
  }

  public updateView(selection: SettingsRoute): void {
    this.changeView.emit(selection);
  }

  /**
   * Will determine which routes to show based on the school type and the current user's role.
   */
  public getRouteOptions(): string[] {
    const allRouteOptions = Object.keys(SettingsRoutesStates);
    let validRoutes;

    // get route options based on school type (JE)
    if (this.is6to12) validRoutes = SCHOOL_TYPE_ROUTES.hybrid;
    else if (this.isHs) validRoutes = SCHOOL_TYPE_ROUTES.hs;
    else validRoutes = SCHOOL_TYPE_ROUTES.ems;

    // remove assessments route if toggle is not on (JE)
    if (!this.showAssessments) validRoutes = filter(validRoutes, route => route !== 'Assessments');

    const routeOptions = allRouteOptions.reduce((routes, route) => {
      if (validRoutes.includes(route)) {
        // make sure option is a valid route for the school type
        if (this.isSchoolWideEditor || this.isCaseloadUser) {
          // make sure the option is valid for the user type
          if (!this.restrictedRoutes.includes(route)) routes.push(route);
        } else {
          routes.push(route);
        }
      }
      return routes;
    }, []);
    return routeOptions;
  }
}
